import { render, staticRenderFns } from "./acciones-correctivas-preventivas-ver.vue?vue&type=template&id=2530ba2c&scoped=true&"
import script from "./acciones-correctivas-preventivas-ver.vue?vue&type=script&lang=js&"
export * from "./acciones-correctivas-preventivas-ver.vue?vue&type=script&lang=js&"
import style0 from "./acciones-correctivas-preventivas-ver.vue?vue&type=style&index=0&id=2530ba2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2530ba2c",
  null
  
)

export default component.exports